import * as types from '../types.js'
import cloneDeep from "bootstrap-vue/esm/utils/clone-deep";

const state = {
    persons: [],
    contacts: [],
    search: null,
    stats: null,
    waitingPersons: true
};
const getters = {
    action: state => {
        if(state.waitingPersons == true){
            return 'loading'
        }
        else if(state.stats == null){
            return 'compiling'
        }
        else{
            return 'idle'
        }
    },
    getPerson: state => id => {
        for(let i=0; i<state.persons.length; i++){
            if(state.persons[i].id == id){
                return cloneDeep(state.persons[i])
            }
        }
    }
};
const actions = {
    [types.PERSONS_DELETE]: async ({commit, dispatch}, personId) => {
        console.log('should delete person')
        if(personId){
            await axios.delete('api/person/'+personId)
        }
        await commit(types.PERSONS_REMOVE, personId)
        await dispatch(types.PERSONS_COMPILE_STATS)
    },
    [types.PERSONS_FETCH]: ({commit, dispatch}, params) => {
        console.log('loading persons')
        console.log(params)
        commit(types.PERSONS_LOADING)
        return axios.get('/api/person', {
            params: params
        }).then(resp => {
            return commit(types.PERSONS_SET, resp.data)
        }).then(() => {
            return dispatch(types.PERSONS_COMPILE_STATS)
        })
        .catch(reason => {
            console.log(reason)
            return Promise.reject(reason)
        })
    },
    [types.PERSONS_UPDATE_PERSON]: ({commit, dispatch}, person) => {
        return new Promise((resolve, reject) => {
            console.log('updating person ...')
            console.log(person)
            let method
            let url
            if(person.id){
                method = 'put',
                url = 'api/person/' + person.id
            }
            else{
                method = 'post'
                url = 'api/person'
            }
            return axios({
                method: method,
                url: url,
                data: {
                    name: person.name,
                    organization: person.organization,
                    comment: person.comment,
                    contacts: person.contacts ? person.contacts : []
                }
            })
            .then(res => {
                console.log('then')
                console.log(res)
                commit(types.PERSONS_SET_PERSON, res.data)
                resolve(JSON.parse(JSON.stringify(res.data)))
            })
            .then(() => {
                console.log('compiling person stats')
                dispatch(types.PERSONS_COMPILE_STATS)
            })
            .catch(err => {
                reject(err.response.data)
            })
        })
    },
    [types.PERSONS_FETCH_PERSON]: ({state}, personId) => {
        for(let i=0; i<state.persons.length; i++){
            if(state.persons[i].id == personId){
                return state.persons[i]
            }
        }
    },
    [types.PERSONS_SEARCH_UPDATE]: ({commit, dispatch}, search) => {
        commit(types.PERSONS_SEARCH_UPDATED, search)
    },
    [types.PERSONS_COMPILE_STATS]: ({commit, state}) => {
        let status = state.persons.reduce((result, person) => {
            result.persons += 1
            let contactStats = person.contacts.reduce(
                (carry, contact) => {
                    if(contact.type == 'phone'){
                        carry.phones += 1
                    }
                    else{
                        carry.emails += 1
                    }
                    return carry
                },
                {phones: 0, emails: 0})
            result.phones += contactStats.phones
            result.emails += contactStats.emails
            return result
        }, {persons:0, phones:0, emails: 0})
        commit(types.PERSONS_STATS_COMPILED, status)
    }
};
const mutations = {
    [types.PERSONS_REMOVE]: (state, personId) => {
        console.log(personId)
        state.persons.splice(
            state.persons.findIndex(
                person => person.id === personId
            ),
            1
        )
    },
    [types.PERSONS_SET_PERSON]: (state, person) => {
        // Vue.set(state.persons, person.index, person)
        state.persons.splice(
            state.persons.findIndex(p => p.id === person.id),
            1,
            person
        )
    },
    [types.PERSONS_LOADING]: function(state, resp){
        state.persons = []
        state.waitingPersons = true
        state.stats = null
    },
    [types.PERSONS_SET]: function(state, resp){
        state.waitingPersons = false
        state.persons = resp
    },
    [types.PERSONS_STATS_COMPILED]: function(state, stats){
        state.stats = stats
    },
    [types.PERSONS_SEARCH_UPDATED]: function(state, search){
        state.search = search;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}